const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');

export function getPluginsConfig() {
  return {
    popColumns: {
      i18n,
    },
  };
}
